import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../BaseComponent';
import { LayoutType } from '../../constants/LayoutConstants';
import { PconLoginStore, PconLoginStoreState, PconLoginOrganization } from '../../stores/PconLoginStore';
import { VisibilityStore } from '../../stores/VisibilityStore';
import { VisibilityActions } from '../../actions/VisibilityActions';
import { PopupMenu } from '../../constants/Enums';
import { PconLoginActions } from '../../actions/PconLoginActions';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { UrlHelper } from '../../utils/UrlHelper';

interface PconLoginBarProps extends React.Props<PconLoginBar> {
    layoutType: LayoutType;
    userLanguage: string;
}

interface PconLoginBarState {
    loginName: string | null;
    loginEmail: string | null;
    organization: string | null;
    open: boolean;
}

export class PconLoginBar extends BaseComponent<PconLoginBarProps, PconLoginBarState> {
    public componentWillMount(): void {
        this.addStoreListener(PconLoginStore, this.onChange);
        this.addStoreListener(VisibilityStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (AppConfigurationStore.getState().noLogin) {
            return null;
        }
        let label: string = '';
        if (this.props.layoutType !== LayoutType.SMALL) {
            if (this.state.loginName == null) {
                label = t('Login');
            } else {
                label = this.state.loginName;
            }
        }
        if (this.state.loginName == null) {
            return (
                <div className="pcon-login-bar">
                    <div
                        className="pcon-login-label no-flag"
                        onClick={PconLoginActions.login}
                    >
                        <span>{label}</span>
                    </div>
                </div>
            );
        }
        return (
            <div className={'pcon-login-bar' + (this.state.open ? ' active' : '')}>
                <div className="pcon-login-label" onClick={this.toggle}>
                    <span>{label}</span>
                    <div className="pcon-login-popup with-popupflag top-arrow align-right">
                        <div className="pcon-login-popup-name">{this.state.loginName}</div>
                        {this.state.organization == null ? null : <div className="pcon-login-popup-info">{this.state.organization}</div>}
                        {this.state.loginEmail == null ? null : <div className="pcon-login-popup-info">{this.state.loginEmail}</div>}
                        <div className="pcon-login-popup-separator"/>
                        <a
                            className="pcon-login-popup-account"
                            href={UrlHelper.getPCONLoginUserProfileLink(this.props.userLanguage)}
                            target="_blank"
                        >
                            {t('User Account')}
                        </a>
                        <div className="pcon-login-popup-logout" onClick={this.logout}>{t('Log out')}</div>
                    </div>
                </div>
            </div>
        );
    }

    protected toggle = (): void => {
        if (this.state.open) {
            VisibilityActions.hidePopupMenu(PopupMenu.LOGIN);
        } else {
            VisibilityActions.setPopupMenu(PopupMenu.LOGIN);
        }
    };

    protected onChange = (): void => {
        let loginName: string | null = null;
        let loginEmail: string | null = null;
        const state: PconLoginStoreState = PconLoginStore.getState();

        if (state.user != null) {
            loginName = PconLoginStore.getUserName();
            loginEmail = state.user.email;
        }

        const organization: PconLoginOrganization | null = PconLoginStore.getState().organization;

        this.setState({
            loginName: loginName,
            loginEmail: loginEmail,
            organization: organization ? organization.name : null,
            open: VisibilityStore.getState().popupMenu === PopupMenu.LOGIN
        });
    };

    protected logout = (): void => {
        VisibilityActions.hidePopupMenu(PopupMenu.LOGIN);
        PconLoginActions.logout();
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/PconLoginBar.tsx